import React from 'react';
import { Box, ButtonBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import {
    CART_SUBTOTAL_TAB_LABEL,
    PROMOTIONS_TAB_CART_SUBTOTAL,
    PROMOTIONS_TAB_QUANTITY,
} from '../../../constants/promotionConfig';
import PromotionsBestOfNotice from './PromotionsBestOfNotice';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
        width: '100%',
    },
    wrapperCompact: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: '100%',
    },
    segmented: {
        display: 'flex',
        gap: 6,
        padding: 4,
        borderRadius: 12,
        backgroundColor: '#ECECF2',
        border: '1px solid #E0E0E6',
        width: '100%',
    },
    tab: {
        flex: 1,
        minHeight: 36,
        padding: '8px 12px',
        borderRadius: 9,
        fontWeight: 600,
        fontSize: 14,
        lineHeight: 1.3,
        color: '#4B5563',
        textAlign: 'center',
        cursor: 'pointer',
        backgroundColor: 'transparent',
        border: '1px solid transparent',
        transition: theme.transitions.create(['background-color', 'color', 'border-color', 'box-shadow'], {
            duration: theme.transitions.duration.short,
        }),
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            color: '#1F2937',
        },
        '&:focus': {
            outline: 'none',
        },
        '&:focus-visible': {
            boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
        },
    },
    tabCompact: {
        minHeight: 32,
        padding: '7px 8px',
        fontSize: 13,
    },
    tabActive: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        border: `1px solid ${theme.palette.primary.main}`,
        boxShadow: '0 2px 8px rgba(23, 51, 0, 0.2)',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            opacity: 0.94,
        },
    },
}));

const TAB_ITEMS = [
    { value: PROMOTIONS_TAB_QUANTITY, label: 'Por cantidad' },
    { value: PROMOTIONS_TAB_CART_SUBTOTAL, label: CART_SUBTOTAL_TAB_LABEL },
];

const PromotionsPageTabs = ({ activeTab, onChange, compact }) => {
    const classes = useStyles();

    return (
        <Box className={compact ? classes.wrapperCompact : classes.wrapper}>
            <Box className={classes.segmented} role="tablist" aria-label="Tipo de descuento">
                {TAB_ITEMS.map((tab) => {
                    const selected = activeTab === tab.value;
                    return (
                        <ButtonBase
                            key={tab.value}
                            role="tab"
                            aria-selected={selected}
                            className={clsx(
                                classes.tab,
                                compact && classes.tabCompact,
                                selected && classes.tabActive
                            )}
                            onClick={() => onChange(tab.value)}
                        >
                            {tab.label}
                        </ButtonBase>
                    );
                })}
            </Box>
            <PromotionsBestOfNotice compact={compact} />
        </Box>
    );
};

export default PromotionsPageTabs;
